import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import deMessages from "devextreme/localization/messages/es.json";
 
import { locale, loadMessages } from "devextreme/localization";

const root = ReactDOM.createRoot(document.getElementById('root'));

loadMessages(deMessages);
        locale(navigator.language);
root.render(
  
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
